import React from 'react';
import PropTypes from 'prop-types';
import he from 'he';
import axios from 'axios';
import LinkHandler from '../../link-handler';
import { emboldenMatchingStrings } from '../helpers';
import { BestBetWrapper, Summary, Label } from '../styles';

const BestBet = ({ trackingUrl, title, summary, searchTerm, path }) => (
  <BestBetWrapper>
    <Label>
      <LinkHandler
        link={{
          path,
          internal: true,
        }}
        onClick={() => axios.request({ url: trackingUrl })}
      >
        {title}
      </LinkHandler>
    </Label>
    {summary && (
      <Summary>
        {emboldenMatchingStrings(he.decode(summary), searchTerm)}
      </Summary>
    )}
  </BestBetWrapper>
);

export default BestBet;

BestBet.propTypes = {
  trackingUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  searchTerm: PropTypes.string,
  path: PropTypes.string.isRequired,
};
